export const CONSTANTS = {
    EMAIL_ATTACHMENT: 'email-attachment',
    ACCESS_AND_REFRESH_TOKEN_INVALID: 'Both Tokens Are Expired',
    GOOGLE: {
        SCOPE: 'openid email profile https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.modify',
        ACCESS_TYPE: 'offline',
        PROMPT: 'consent',
        FLOW: 'auth-code',
        UX_MODE: 'popup',
        STATE: 'check'
    },
    TOAST_MESSAGES: {
        SUCCESS: {
            NEW_EMAIL: 'You Have Got A New Email!',
            EMAIL_DETAILS_SAVED: 'Email Details Saved Successfully',
            EMAIL_SENT: 'Email Sent Successfully',
            EMAIL_LOGIN_SUCCESS: 'Email Registered Successfully',
            EMAIL_LOGIN_UPDATE_SUCCESS: 'Expired Email Updated Successfully',
            NOTI_MODIFICATION_SUCCESS: 'Updated Notification Successfully'
        },
        WARNING: {
            TOKENS_VALIDATION_ERROR: 'Unable To Authenticate Tokens'
        },
        DANGER: {
            EMAIL_DETAILS_SAVED_ERROR: 'Error Occured While Saving Email Details',
            EMAIL_LOGIN_ERROR: 'Error Occured While Login',
            EMAIL_LOGIN_UPDATE_ERROR: 'Error Occured While Updating Expired Email',
            NOTI_CREATE_ERROR: 'Unable To Save Notification',
            NOTI_MODIFICATION_ERROR: 'Unable To Update Notification'
        }
    },
    STATUS: {
        REJECTED_STOPPED_SEQUENCING: 'Rejected - Stopped Sequencing',
        IN_CALLS: 'In Calls',
        APPROVED: 'Approved',
        IN_QA: 'In Qa',
        PROGRESS: 'Match in Progress',
        MARKED_COMPLETE: 'Match Marked Complete',
        MATCHING_COMPLETE_IN_PROGRESS: "Mark Matching Complete In Progress",
        MATCHING_COMPLETE: 'Matching Complete',
        RERUN_MATCHING: 'reRunning Matching',
        FAILED: 'Failed'
    },
    ROUTES: {
        DOMAIN: '/settings/access/domains',
        PARTNERS: '/settings/access/partners',
        USERS: '/settings/access/users',
        MATCHING: '/settings/app/matching',
        CALLING: '/settings/app/calling',
        EMAILING: '/settings/app/emailing',
        TASKS_EMAIL_TAB: '/tasks/emails',
        TASKS_TASK_TAB: '/tasks/task',
        TASKS_NOTIFICATION_TAB: '/tasks/notifications',
        TASKS_NOTIFICATION_DETAIL_TAB: '/tasks/notifications/emailDetail',
        TASKS_NOTIFICATION_MISSED_CALL_DETAIL_TAB: '/tasks/notifications/missedCallDetail',
        TASKS_NOTIFICATION_REJECTED_SUP_DETAIL_TAB: '/tasks/notifications/rejectedSupplierDetail'
    },
    ROLE_NAME: {
        ADMIN: 'admin',
        MODERATOR: 'moderator',
        USER: 'user',
    },
    ROLE_ID: {
        ADMIN: 3,
        MODERATOR: 2,
        USER: 1
    },
    LIMIT: [
        {
            label: '10',
            value: 10,
        },
        {
            label: '20',
            value: 20,
        },
        {
            label: '30',
            value: 30,
        },
        {
            label: '50',
            value: 50,
        },
        {
            label: '100',
            value: 100,
        },
    ],
    API: {
        RECORDING_URL: `https://api.twilio.com/2010-04-01/Accounts/ACaefc30f519f53651b179eb9301f1c11a/Recordings/`
    },
    API_RES_MESSAGE: {
        LINK_TO_VENDOR_SUCCESS: "Voicemail Linked to Vendor successfully!",
        CREATED_SUCCESS: 'Created Successfully',
        MODIFIED_SUCCESS: 'Modified Successfully',
        UPDATED_SUCCESS: 'Updated Successfully',
        DELETED_SUCCESS: 'Deleted Successfully',
    },
    TASK_TABS: {
        EMAILS: 'emails',
        TASKS: 'tasks',
        NOTIFICATIONS: 'notifications'
    },
    EMAIL_CURRENT_PAGE: {
        INBOX:'inbox',
        SENT: 'sent',
        DRAFT: 'draft',
        EMAIL_DETAIL: 'emailDetails'
    },
    NOTI_SUB_TABS: {
        EMAILS: 'emails',
        MISSED_CALLS: 'missedCalls',
        MISSED_CALL_DETAILS: 'missedCallDetails',
        REJECTED_SUPPLIERS: 'rejectedSuppliers',
        PARTNER_SUBMISSIONS: 'partnerSubmissions',
        NOTI_DETAIL: 'notificationDetail'
    },
    MODAL_MESSAGE: {
        MARK_AS_READ: 'Are you sure you want to modify unread notification to read?',
        MARK_AS_UNREAD: 'Are you sure you want to modify read notification to unread?',
        DELETE_NOTI: 'Are you sure you want to delete this notification?'
    }
}
